export default __webpack_public_path__ + "static/media/users-solid.c2ccc00d.svg";